/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
// this is used to create scrollbars on windows devices like the ones from apple devices
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// react component that creates notifications (like some alerts with messages)
import NotificationSystem from "react-notification-system";

import Sidebar from "components/Sidebar/Sidebar.jsx";
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.jsx";
import NotFoundPage from "views/Pages/notFound.jsx";
import image from "assets/img/full-screen-image-3.jpg";
import { generateToken, messaging } from "notifications/firebase";
import { onMessage } from "firebase/messaging";

// dinamically create dashboard routes
import routes from "routes.js";

// style for notifications
import { style } from "variables/Variables.jsx";

var ps;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _notificationSystem: null,
      image: image,
      color: "black",
      hasImage: true,
      navbar: false,
      mini: false,
      fixedClasses: "dropdown show-dropdown open",
    };
  }

  componentDidMount() {
    if (!localStorage.getItem("orderIds")) {
      localStorage.setItem("orderIds", JSON.stringify([]));
    }

    generateToken(this.refs.notificationSystem);

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    onMessage(messaging, (payload) => {
      const orderId = payload.data.orderId;

      // Retrieve the array from localStorage
      const orderIds = JSON.parse(localStorage.getItem("orderIds"));

      if (!orderIds.includes(orderId)) {
        // Add the orderId to the array
        orderIds.push(orderId);
        // Save the updated array back to localStorage
        localStorage.setItem("orderIds", JSON.stringify(orderIds));

        var color = Math.floor(Math.random() * 4 + 1);
        var level;
        switch (color) {
          case 1:
            level = "success";
            break;
          case 2:
            level = "warning";
            break;
          case 3:
            level = "error";
            break;
          case 4:
            level = "info";
            break;
          default:
            break;
        }

        if (payload.data.orderType === "Medicine") {
          level = "error";
        } else if (payload.data.orderType === "Raya") {
          level = "warning";
        } else if (payload.data.orderType === "Lab") {
          level = "info";
        }

        this.state._notificationSystem.addNotification({
          title: (
            <div
              className="pe-7s-note2"
              // style={{ margin: "18px 51px 0px", fontSize: "16px" }}
            >
              {/* {`Order ID ${payload.data.orderId}`} */}
            </div>
          ),
          message: (
            <div style={{ fontSize: "20px" }}>
              {`You have a new ${payload.data.orderType} order`}
            </div>
          ),
          level: level,
          position: "tr",
          autoDismiss: 15,
        });
      }
    });
  }

  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
    if (
      window.innerWidth < 993 &&
      e.history.action === "PUSH" &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  componentWillMount() {
    if (document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  // function that shows/hides notifications - it was put here, because the wrapper div has to be outside the main-panel class div
  handleNotificationClick = (position, title, message) => {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    this.state._notificationSystem.addNotification({
      title: title ? title : <span data-notify="icon" className="pe-7s-gift" />,
      message: message ? (
        message
      ) : (
        <div>
          Welcomewwwwww to <b>Light Bootstrap Dashboard</b> - a beautiful
          freebie for every web developer.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  };
  handleImageClick = (image) => {
    this.setState({ image: image });
  };
  handleColorClick = (color) => {
    this.setState({ color: color });
  };
  handleHasImage = (hasImage) => {
    this.setState({ hasImage: hasImage });
  };
  handleNavbarClick = (navbar) => {
    this.setState({ navbar: navbar });
  };
  handleMiniClick = () => {
    this.setState({ mini: !this.state.mini });
    document.body.classList.toggle("sidebar-mini");
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === "dropdown") {
      this.setState({ fixedClasses: "dropdown show-dropdown open" });
    } else {
      this.setState({ fixedClasses: "dropdown" });
    }
  };
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            key={key}
            render={(routeProps) => (
              <div
                className="no_scroll_pagewrap"
                style={{ maxHeight: "calc(100vh - 137px)", overflow: "auto" }}
              >
                <prop.component
                  {...routeProps}
                  handleClick={this.handleNotificationClick}
                />
              </div>
            )}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar
          {...this.props}
          image={this.state.image}
          color="#E02E40"
          hasImage={this.state.hasImage}
          mini={this.state.mini}
        />
        <div
          className={
            "main-panel" +
            (this.props.location.pathname === "/maps/full-screen-maps"
              ? " main-panel-maps"
              : "")
          }
          ref="mainPanel"
        >
          <AdminNavbar
            {...this.props}
            handleMiniClick={this.handleMiniClick}
            navbar={this.state.navbar}
          />
          <Switch>
            {this.getRoutes(routes)}
            {/*  <Route component={NotFoundPage} /> */}
          </Switch>
          <Footer fluid />
          <FixedPlugin
            handleImageClick={this.handleImageClick}
            handleColorClick={this.handleColorClick}
            handleHasImage={this.handleHasImage}
            handleNavbarClick={this.handleNavbarClick}
            handleMiniClick={this.handleMiniClick}
            bgColor={this.state["color"]}
            bgImage={this.state["image"]}
            mini={this.state["mini"]}
            handleFixedClick={this.handleFixedClick}
            fixedClasses={this.state.fixedClasses}
          />
        </div>
      </div>
    );
  }
}

export default Dashboard;
